import React from "react";
import { CheckHistoryBarProps } from "./types";
import classes from "./check-history-bar.module.scss";

export const CheckHistoryBar = ({ vin, setVin, error, onSubmit }: CheckHistoryBarProps) => {
    return (
        <div className={classes["check-bar"]}>
            <form className={classes["check-bar__form"]} onSubmit={onSubmit}>
                <p className={classes["check-bar__title"]}>Проверьте историю автомобиля</p>
                <p className={classes["check-bar__slogan"]}>
                    Полноценная проверка по официальным базам: ДТП, залоги, пробег и полная
                    сервисная история
                </p>
                <div className={classes["check-bar__wrapper"]}>
                    <input
                        className={classes["check-bar__input"]}
                        type="text"
                        placeholder="Госномер, VIN или номер кузова"
                        value={vin}
                        onChange={(e) => setVin(e.target.value)}
                    />
                    <button className={classes["check-bar__button"]} type="submit">
                        Проверить
                    </button>
                </div>
                {error && (
                    <div className={classes["check-bar__error"]}>
                        Неправильный госномер, VIN или номер кузова
                    </div>
                )}
            </form>
        </div>
    );
};